import { ModalProps } from '~/ui/Modal'
import TemplatesModal from '../TemplatesModal'
import GableScreen from './screens/GableScreen'
import MonoslopeScreen from './screens/MonoslopeScreen'

const screens = [
  {
    key: 'gable',
    title: 'Gable',
    component: GableScreen,
    icon: 'gable' as const,
  },
  {
    key: 'monoslope',
    title: 'Monoslope',
    component: MonoslopeScreen,
    icon: 'monoslope' as const,
  },
]

const RoofTemplatesModal = (props: ModalProps) => <TemplatesModal title="Roof Templates" screens={screens} {...props} />

export default RoofTemplatesModal
